type ContentsServiceCode = '2201';
export const CONTENTS_SERVICE_CODE: ContentsServiceCode = '2201' as const;

export const ACCOUNT_1_0_CONTENTS_REQUIREMENTS_SCHEME = {
  GUIDE_CODE: 'STOCK_CONTENTS',
  T_CH: 'payapp_stock_contents',
} as const;
